import React, { Fragment } from 'react'
import Nav from '../../components/NavBar/Nav'
import Footer from '../../components/Footer/Footer'
import LuckyWheel from '../../components/SpinWin/SpinWin'
const index = () => {
  return (
    <Fragment>
        <Nav/>
        <LuckyWheel/>
        <Footer/>
    </Fragment>
  )
}

export default index